
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/investor/csr-reports",
      function () {
        return require("private-next-pages/investor/csr-reports.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/investor/csr-reports"])
      });
    }
  